import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReportHeader from '../components/ReportHeader';

/** Every insight page, grouped by the data it reads. */
const SECTIONS = [
  {
    title: 'Whereabouts',
    reports: [
      { to: '/data-insights/office-weekdays', title: 'Office days by weekday', desc: '"Tuesday is the new Monday": which weekday people actually come in.' },
      { to: '/data-insights/whereabouts-split', title: 'Home vs office split', desc: 'The overall balance of home, office and holiday.' },
      { to: '/data-insights/split-days', title: 'The lunchtime commute', desc: 'Days where morning and afternoon locations differ.' },
      { to: '/data-insights/custom-labels', title: 'What teams call working elsewhere', desc: 'The custom whereabouts statuses companies invent.' },
    ],
  },
  {
    title: 'Bookings',
    reports: [
      { to: '/data-insights/desk-loyalty', title: 'The golden desk', desc: 'How loyal people are to their favourite desk.' },
      { to: '/data-insights/meeting-lead-time', title: 'When meeting rooms get booked', desc: 'The hour of day rooms are booked, and how many at the last minute.' },
      { to: '/data-insights/meeting-lengths', title: 'Meeting length reality check', desc: 'The tyranny of the 30- and 60-minute slot.' },
      { to: '/data-insights/visitor-weekdays', title: 'Visitor patterns', desc: 'Which day is busiest at the front desk.' },
      { to: '/data-insights/parking-weekdays', title: 'Parking pressure', desc: 'When the office car park is busiest.' },
    ],
  },
  {
    title: 'People',
    reports: [
      { to: '/data-insights/holiday-patterns', title: 'Holiday patterns', desc: 'When people book their annual leave.' },
      { to: '/data-insights/workplace-heroes', title: 'Workplace heroes', desc: 'First aiders, fire wardens and mental-health aiders.' },
    ],
  },
];

const DataInsights = () => (
  <Container fluid className="py-4">
    <ReportHeader
      title="Data insights"
      description="Aggregate, anonymised stats across all Team Today data, built for social-media posts."
    />

    {SECTIONS.map((section) => (
      <section key={section.title} className="mb-4" aria-labelledby={`insights-${section.title}`}>
        <h2 id={`insights-${section.title}`} className="h6 text-muted mb-3">{section.title}</h2>
        <Row className="g-3 g-md-4">
          {section.reports.map((r) => (
            <Col key={r.to} md={6} lg={4}>
              <Card as={Link} to={r.to} className="shadow-sm h-100 text-decoration-none text-reset">
                <Card.Body>
                  <Card.Title as="h3" className="h5">{r.title}</Card.Title>
                  <Card.Text className="text-muted mb-0">{r.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>
    ))}
  </Container>
);

export default DataInsights;
